import styled, { css } from 'styled-components';
import { themeContract } from './ProgressTracker.theme.contract';
var Tracker = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Tracker",
  componentId: "fgew7w-0"
})(["display:flex;justify-content:space-between;position:relative;&::after{content:'';margin:0 auto;position:absolute;top:18px;left:35px;right:35px;bottom:0;z-index:1;border-top:1px solid ", ";}"], function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].tracker.borderColor];
});
var Step = styled.button.withConfig({
  displayName: "ProgressTrackerstyles__Step",
  componentId: "fgew7w-1"
})(["flex-direction:column;background:none;border:0;z-index:2;padding:1px 3px 2px;flex:0 0 auto;font-family:inherit;@media (-ms-high-contrast:active),(-ms-high-contrast:none){flex:1;}", ""], function (props) {
  return props.disabled && css(["cursor:not-allowed;"]);
});
var Marker = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Marker",
  componentId: "fgew7w-2"
})(["display:flex;align-items:center;justify-content:center;width:35px;height:35px;color:", ";font-size:", ";border:1px solid ", ";border-radius:50%;margin:0 auto;margin-bottom:5px;background:", ";box-shadow:0 0 0 3px ", ";svg{fill:", ";width:1.2rem;height:1.2rem;}", " ", ""], function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].marker.color];
}, function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].marker.borderColor];
}, function (props) {
  return props.theme.color.palette.white;
}, function (props) {
  return props.boxShadow || props.theme.color.palette.white;
}, function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].marker.color];
}, function (props) {
  return props.active && css(["color:", ";background:", ";font-weight:", ";"], props.theme.color.palette.white, props.theme.color.palette[themeContract[props.theme.channel].marker.active.background], props.theme.font.weight.bold);
}, function (props) {
  return props.disabled && css(["color:", ";border-color:", ";"], props.theme.color.monochrome.base, props.theme.color.monochrome.base);
});
var Label = styled.span.withConfig({
  displayName: "ProgressTrackerstyles__Label",
  componentId: "fgew7w-3"
})(["font-family:", ";font-weight:", ";font-size:", ";display:flex;justify-content:center;margin-top:7px;", " ", ""], function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.active && css(["font-weight:", ";"], props.theme.font.weight.bold);
}, function (props) {
  return props.disabled && css(["color:", ";font-weight:", ";"], props.theme.color.monochrome.base, props.theme.font.weight.regular);
});
export { Tracker, Step, Marker, Label };